"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Apiv2ServiceException = exports.__ServiceException = void 0;
const smithy_client_1 = require("@smithy/smithy-client");
Object.defineProperty(exports, "__ServiceException", { enumerable: true, get: function () { return smithy_client_1.ServiceException; } });
class Apiv2ServiceException extends smithy_client_1.ServiceException {
    constructor(options) {
        super(options);
        Object.setPrototypeOf(this, Apiv2ServiceException.prototype);
    }
}
exports.Apiv2ServiceException = Apiv2ServiceException;
